import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import { CheckIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import { StyledModalCloseButton } from '../../Basic/Modal/Modal.styles.mjs';
import { StyledModal, StyledRegionsGrid, StyledButton } from './RegionSelectionModal.styles.mjs';
import { useTheme } from 'styled-components';

const RegionSelectionModal = ({ heading, regions, selectedRegion, isOpen, onClose, onRegionSelect }) => {
    const theme = useTheme();
    return (React.createElement(StyledModal, { title: heading, isOpen: isOpen },
        React.createElement(StyledModalCloseButton, { type: "button", iconType: "close", onClick: onClose }),
        React.createElement(StyledRegionsGrid, null, regions.map(region => (React.createElement(StyledButton, { ariaLabel: `Select ${region.name} region`, key: region.id, variant: region.id === selectedRegion.id ? 'primary' : 'outline', size: Size.Regular, onClick: () => onRegionSelect(region) },
            region.id === selectedRegion.id && React.createElement(CheckIcon, { color: theme.colors.white }),
            region.name))))));
};

export { RegionSelectionModal as default };
//# sourceMappingURL=RegionSelectionModal.mjs.map
